import { render, staticRenderFns } from "./gift-card-container.vue?vue&type=template&id=f9925c38&"
import script from "./gift-card-container.vue?vue&type=script&lang=js&"
export * from "./gift-card-container.vue?vue&type=script&lang=js&"
import style0 from "./gift-card-container.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports